'use client';

import { useRef } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { generateChartbeatConfig } from '@benzinga/analytics';
import { PageProps } from '../../../src/components/Page';

export const ChartbeatAnalyticsV2: React.FC<{ pageProps?: PageProps }> = ({ pageProps }) => {
  const inserted = useRef(false);
  const tags = pageProps?.article?.tags || [];
  const channels = pageProps?.article?.channels || [];
  const authorName = pageProps?.article?.name || '';
  const sections = channels.concat(tags)?.map(({ name }: { name: string }) => name) || [];
  const chartbeatConfig = generateChartbeatConfig({
    authorName,
    chartBeatDomain: 'benzinga.com',
    sections,
    uid: process.env.CHARTBEAT_KEY as string,
  });

  useServerInsertedHTML(() => {
    if (inserted.current) return null;
    inserted.current = true;
    return (
      <script
        // eslint-disable-next-line benzinga/no-unsanitized-innerhtml
        dangerouslySetInnerHTML={{ __html: chartbeatConfig }}
        id="chartbeat"
      />
    );
  });

  return (
    <>
      <link as="script" href="https://static.chartbeat.com/js/chartbeat.js" rel="preload" />
      <script async src="https://static.chartbeat.com/js/chartbeat_mab.js" />
    </>
  );
};
